import clsx from 'clsx';

import { twMerge } from '@polyai/ui/utils/twMerge';

interface Props {
  className?: string;
}

export const OverflowGradientBlock = ({ className, ...props }: Props) => {
  return (
    <div
      className={twMerge(
        clsx('absolute right-0 top-0 bottom-0 w-sm1', className),
      )}
      style={{
        // Somehow `bg-gradient-to-r from-transparent to-background-page` doesn't work in this case
        background: 'linear-gradient(to right, transparent, var(--grey-05))',
      }}
      {...props}
    />
  );
};
